import(/* webpackMode: "eager", webpackExports: ["CatwalkLayoutProvider"] */ "/opt/build/repo/packages/apg/frontend/frontasticBridge/catwalk/js/CatwalkLayoutProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyScripts"] */ "/opt/build/repo/packages/apg/frontend/frontasticBridge/catwalk/js/component/thirdPartyScripts.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/sportscraft/frontend/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/sportscraft/frontend/legacy/scss/app.scss");
